@import 'styles/mixins';
@import 'styles/variables';

.td {
  padding: 4px 12px 4px 14px;
  height: 100%;
}
